import React from 'react'

function  ErrorMessage({error}) {
  return (
    <div>
      <p className="text-star_color text-sm">{error}</p>
    </div>
  );
}

export default ErrorMessage
